import {
    EdProgramDto,
    EdProgramStatus,
    EdProgramTypeFollowLink,
    EdProgramTypeSubscribe,
} from 'src/types/EdProgram/EdProgram';

export const isEdProgramTypeFollowLink = (edProgram: EdProgramDto): edProgram is EdProgramTypeFollowLink =>
    edProgram.status === EdProgramStatus.READY;

export const isEdProgramTypeSubscribe = (edProgram: EdProgramDto): edProgram is EdProgramTypeSubscribe =>
    edProgram.status === EdProgramStatus.PROGRESS;
